module.exports = __webpack_public_path__ + "img/lost-continent-of-mu.039396bb.jpg";